import { QuestelServicesClient } from '@questelservices/common';
import store from '@/store';
import { Country } from '@/models/Countries/Country';
import { State } from '@/models/Countries/State';

export class CountryService {
  private client: QuestelServicesClient;

  constructor() {
    this.client = new QuestelServicesClient(store, "/api");
  }

  public async getCountryList(): Promise<Array<Country>> {
    return await this.client.get<Array<Country>>(`/v1/countries`);
  }
}